import {FONT_SIZE_UNIT_TYPES} from '../../constants/fontSettingTypes';

export const PRIMARY_LIGHT = '#666';
export const PRIMARY_MAIN = '#fff';
export const PRIMARY_DARK = '#000';
export const PRIMARY_CONTRAST_TEXT = '#bbb';

export const SECONDARY_LIGHT = '#ff7961';
export const SECONDARY_MAIN = '#e1342e'; // Spiria logo red
export const SECONDARY_DARK = '#ba000d';
export const SECONDARY_CONTRAST_TEXT = '#000';

export const SUCCESS = 'darkseagreen';
export const WARNING = '#ffa000';

export const HEADER_BACKGROUND = '#2a2a2a';
export const DIALOG_HEADER = '#424242';

const styles = {
    _theme: () => ({
        palette: {
            primary: {
                light: PRIMARY_LIGHT,
                main: PRIMARY_MAIN,
                dark: PRIMARY_DARK,
                contrastText: PRIMARY_CONTRAST_TEXT
            },
            secondary: {
                light: SECONDARY_LIGHT,
                main: SECONDARY_MAIN,
                dark: SECONDARY_DARK,
                contrastText: SECONDARY_CONTRAST_TEXT,
            },
            type: 'dark'
        },
        overrides: {
            MuiDialogContent: {
              root: {
                  backgroundColor: HEADER_BACKGROUND,
                  borderLeft: `4px ${DIALOG_HEADER} solid`,
                  borderRight: `4px ${DIALOG_HEADER} solid`,
                  margin: 0,
                  padding: '20px 0'
              }
            },
            MuiFormLabel: {
                root: {
                    display: 'inline-flex'
                }
            },
            MuiFormControlLabel: {
                root: {
                    marginLeft: -2
                }
            },
            MuiIconButton: {
                root: {
                    padding: 0
                }
            },
            MuiInputLabel: {
                formControl: {
                    alignItems: 'center'
                }
            },
            MuiList: {
                padding: {
                    paddingBottom: 0,
                    paddingTop: 0
                }
            },
            MuiPickersDay: {
                isSelected: {
                    backgroundColor: SECONDARY_MAIN,
                    fontWeight: 600
                },
                current: {
                    textDecoration: `underline ${SECONDARY_MAIN}`
                }
            },
            MuiPickersClock: {
                pin: {
                    backgroundColor: SECONDARY_MAIN
                },
            },
            MuiPickersClockPointer: {
                noPoint: {
                    backgroundColor: SECONDARY_MAIN
                },
                pointer: {
                    backgroundColor: SECONDARY_MAIN
                },
                thumb: {
                    backgroundColor: SECONDARY_MAIN,
                    borderColor: SECONDARY_MAIN
                }
            },
            MuiSelect: {
                root: {
                    height: '100%'
                },
            },
            MuiSnackbarContent: {
                message: {
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center'
                }
            },
            MuiTableCell: {
                root: {
                    padding: '4px 24px'
                }
            },
            MuiTooltip: {
                tooltip: {
                    borderRadius: 4,
                    color: PRIMARY_MAIN,
                    fontSize: 14,
                    margin: '4px 16px 4px 0',
                    padding: '10px 10px'
                }
            }
        },
        typography: {
            useNextVariants: true,
        }
    }),
    autoSuggest: () => ({
        theme: {
            container: {
                flexGrow: 1,
                position: 'relative'
            },
            suggestionsContainerOpen: {
                position: 'absolute',
                zIndex: 1,
                marginTop: 0,
                left: 0,
                right: 0,
            },
            suggestion: {
                display: 'block',
            },
            suggestionsList: {
                margin: 0,
                padding: 0,
                listStyleType: 'none',
            }
        }
    }),
    slideDuration: props => ({
        transition: props && props.deactivating ? 'none' : `width ${props.duration - 250}ms linear`
    }),
    slideFont: props => {
        if (!props) {
            return null;
        }
        const styles = {};
        if (props.color) {
            styles.color = props.color;
        }
        if (props.lineHeight && props.lineHeightUnits) {
            styles.lineHeight = `${props.lineHeight}${FONT_SIZE_UNIT_TYPES[props.lineHeightUnits].text}`;
        }
        if (props.size && props.sizeUnits) {
            styles.fontSize = `${props.size}${FONT_SIZE_UNIT_TYPES[props.sizeUnits].text}`;
        }
        if (props.weight) {
            styles.fontWeight = props.weight;
        }
        return styles;
    },
    slideImage: props => {
        if (!props) {
            return null;
        }
        const styles = {};
        if (props.objectFit) {
            styles.objectFit = props.objectFit ? props.objectFit : 'contain';
        }
        if (props.horizontalPosition || props.verticalPosition) {
            styles.objectPosition = `${props.verticalPosition ? props.verticalPosition : 'center'} ${props.horizontalPosition ? props.horizontalPosition : 'center'}`;
        }
        return styles;
    },
    snackbar: theme => ({
        success: {
            backgroundColor: SUCCESS,
        },
        error: {
            backgroundColor: theme.palette.error.dark,
        },
        info: {
            backgroundColor: theme.palette.primary.main,
        },
        warning: {
            backgroundColor: WARNING,
        },
        icon: {
            fontSize: 20,
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing.unit,
        },
        message: {
            display: 'flex',
            alignItems: 'center',
        }
    }),
    videoFrame: () => ({
        // if changed, verify matching styles.css vars are updated!
        height: 180,
        width: 320
    })
};

export default styles;


// WEBPACK FOOTER //
// ./src/components/common/styles.js